export default `query($articleId: String! ,$type: String,) {
      itemStatus(articleId: $articleId, type: $type) {
        status
        buy_box_winner
    
      }
  }
`;